import { ZillowPreferredLayout } from '@zillow/zrs-cms';
import Head from 'next/head';
import React from 'react';

import ContentTemplate from '../../components/ContentTemplate';
import LayoutWrapper from '../../components/LayoutWrapper';
import {
    buildPrimaryPostPage,
    LayoutComponentProps,
} from '../../util/buildPrimaryPostPage';

export const Layout: React.FC<LayoutComponentProps> = (props) => {
    return (
        <>
            <Head>
                <link
                    rel="preload"
                    href="//www.zillowstatic.com/s3/constellation-website/public/shared/fonts/object-sans/latest/object-sans-bold.woff2"
                    as="font"
                    type="font/woff2"
                    crossOrigin="anonymous"
                />
                <link
                    rel="preload"
                    href="//www.zillowstatic.com/s3/constellation-website/public/shared/fonts/object-sans/latest/object-sans-regular.woff2"
                    as="font"
                    type="font/woff2"
                    crossOrigin="anonymous"
                />
                <style>
                    {`
                    @font-face {
                        font-family: 'Object Sans';
                        src: url('https://www.zillowstatic.com/s3/constellation-website/public/shared/fonts/object-sans/latest/object-sans-bold.woff2') format('woff2');
                        font-weight: 700;
                        font-style: normal;
                    }
                    @font-face {
                        font-family: 'Object Sans';
                        src: url('https://www.zillowstatic.com/s3/constellation-website/public/shared/fonts/object-sans/latest/object-sans-regular.woff2') format('woff2');
                        font-weight: 400;
                        font-style: normal;
                    }
                    `}
                </style>
            </Head>
            <LayoutWrapper
                {...props}
                LayoutComponent={ZillowPreferredLayout}
                defaultTitle="Zillow Preferred"
                knotchAccountId={
                    process.env.NEXT_PUBLIC_KNOTCH_PA_LAYOUT_ACCOUNT_ID
                }
            />
        </>
    );
};

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryPostPage({
        site: 'PREFERRED',
        basePath: '/preferred',
        ContentComponent: ContentTemplate,
        LayoutComponent: Layout,
        knotchAccountId: process.env.NEXT_PUBLIC_KNOTCH_PA_LAYOUT_ACCOUNT_ID,
        contentType: 'B2C',
        menuPropName: 'submenu',
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
